export default __webpack_public_path__ + "static/media/notif.251cd5e5.mp3";